import { Capacitor, CapacitorCookies } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { isCameraOriginal } from './device-data.business';

export const clearWebViewCookies = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  await CapacitorCookies.clearAllCookies();
};

export const deleteCachedCameraOriginals = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  const { files } = await Filesystem.readdir({ path: '', directory: Directory.Cache });
  await Promise.all(
    files
      .filter(file => isCameraOriginal(file.name))
      .map(file => Filesystem.deleteFile({ path: file.name, directory: Directory.Cache }))
  );
};
